import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-11cf13e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "client-statistics-cards" }

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import StatisticsCards from '@/views/dashboard/_components/statistics-cards/statistics-cards.vue'
import type { StatisticsCardItem } from '@/views/dashboard/_components/statistics-cards/statistics-cards.vue'
import type { GroupClientStatCardKey } from './group-client-statistics-cards.types'


export default /*#__PURE__*/_defineComponent({
  __name: 'statistics-cards',
  props: {
    totalTerminals: { default: 0 },
    onlineCount: { default: 0 },
    offlineCount: { default: 0 },
    todayJoinCount: { default: 0 },
    todayLeaveCount: { default: 0 },
    buyCount: { default: 0 },
    exceedCount: { default: 0 },
    expireCount: { default: 0 },
    peripheralsApprovalCount: { default: 0 },
    sendFileApprovalCount: { default: 0 },
    hideSubscribeCard: { type: Boolean, default: false }
  },
  emits: ["statClick"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n()

const emit = __emit
const props = __props

/** 第一行：终端规模与动态（+ 可选已订阅）；列宽合计 24；可点项用 item.events （见 statistics-events skill） */
const primaryRowItems = computed((): StatisticsCardItem[] => {
  const base: Omit<StatisticsCardItem, 'span'>[] = [
    {
      label: t('groupClient.totalTerminals'),
      value: props.totalTerminals,
      clickable: true,
      events: { click: () => emit('statClick', 'total') }
    },
    {
      label: t('groupClient.currentOnline'),
      value: props.onlineCount,
      clickable: props.onlineCount > 0,
      events: {
        click: () => {
          if (props.onlineCount <= 0) return
          emit('statClick', 'online')
        }
      }
    },
    {
      label: t('groupClient.currentOffline'),
      value: props.offlineCount,
      clickable: props.offlineCount > 0,
      events: {
        click: () => {
          if (props.offlineCount <= 0) return
          emit('statClick', 'offline')
        }
      }
    },
    {
      label: t('groupClient.todayJoin'),
      value: props.todayJoinCount,
      clickable: props.todayJoinCount > 0,
      events: {
        click: () => {
          if (props.todayJoinCount <= 0) return
          emit('statClick', 'todayJoin')
        }
      }
    },
    {
      label: t('groupClient.todayLeaveCount'),
      value: props.todayLeaveCount,
      clickable: props.todayLeaveCount > 0,
      events: {
        click: () => {
          if (props.todayLeaveCount <= 0) return
          emit('statClick', 'todayLeave')
        }
      }
    }
  ]
  const n = base.length
  const spans =
    n === 5 ? [5, 5, 5, 5, 4] : [4, 4, 4, 4, 4, 4]
  return base.map((item, i) => ({ ...item, span: spans[i] }))
})

/** 第二行：与 /homepage/stats/terminal 其余字段对齐 */
const secondaryRowItems = computed((): StatisticsCardItem[] => [
  { label: t('groupClient.statExceedLimit'), value: props.exceedCount, span: 6 },
  { label: t('groupClient.statServiceExpired'), value: props.expireCount, span: 6 },
  { label: t('groupClient.statPeripheralApproval'), value: props.peripheralsApprovalCount, span: 6 },
  { label: t('groupClient.statFileOutboundApproval'), value: props.sendFileApprovalCount, span: 6 }
])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(StatisticsCards, { items: primaryRowItems.value }, null, 8, ["items"])
  ]))
}
}

})